import { TGenericBlueprintSchema } from "@adapptio/lib-blueprint";

export const controlHiddenProp = (schema: TGenericBlueprintSchema) => {
	if (
		schema.opts?.hidden ||
		schema.name === "scopedTemplate" ||
		schema.opts?.["value"]?.name === "scopedTemplate" ||
		schema.name === "void"
	) {
		return true;
	}

	return false;
};
